import React from "react";
import Checkbox from "./Checkbox";
import styles from "./FormFields.css";
import Input from "./Input";
import Label from "./Label";
import Radiobutton from "./Radiobutton";

const Choice = ({
    idPrefix,
    field: { id, label, values, required },
    selected,
    children,
    multiple,
    onChange,
}) => {
    const selectedArray = Array.isArray(selected) ? selected : [selected];

    const labels = [
        values[0] || { label: "Ja", value: "Ja" },
        values[1] || { label: "Nein", value: "Nein" },
        ...(values || []).slice(2),
    ];

    const itemsClasses = [
        styles.ChoiceItems,
        labels.length <= 2 ? styles.ChoiceItemsInline : null,
    ].filter((a) => a);

    const toggleValue = function (value) {
        const selectedCopy = selectedArray.slice();
        var index = selectedCopy.indexOf(value);

        if (index === -1) {
            selectedCopy.push(value);
        } else {
            selectedCopy.splice(index, 1);
        }

        return selectedCopy;
    };

    return (
        <div className={styles.Choice}>
            <p className={styles.Label}>{label}</p>
            <ul className={itemsClasses.join(" ")}>
                {labels?.map((item, itemIndex) => {
                    const props = {
                        name: `${idPrefix}-${id}`,
                        value: item.value,
                        checked: selectedArray.indexOf(item.value) >= 0,
                        onChange: (e) => {
                            onChange(
                                multiple
                                    ? toggleValue(e.target.value)
                                    : selectedArray.indexOf(item.value) >= 0
                                        ? undefined
                                        : item.value
                            );
                        },
                    };

                    return (
                        <li key={itemIndex} className={styles.ChoiceItem}>
                            {multiple ? (
                                <Checkbox
                                    {...props}
                                    required={
                                        required &&
                                        (!selectedArray ||
                                            selectedArray.length == 0)
                                    }
                                >
                                    {item.label}
                                </Checkbox>
                            ) : (
                                <Radiobutton {...props} required={required}>
                                    {item.label}
                                </Radiobutton>
                            )}
                        </li>
                    );
                })}
            </ul>
            {selectedArray.indexOf(labels[0].value) >= 0 && children}
        </div>
    );
};

const FIELDS = {
    TEXT: (idPrefix, field, value, onChange) => (
        <>
            <label className={styles.Label}>{field.label}</label>
            <Input
                name={field.id}
                type="text"
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
                required={field.required}
            />
        </>
    ),
    BOOL: (idPrefix, field, value, onChange) => (
        <label className={styles.Label}>
            <Input
                name={field.id}
                type="checkbox"
                checked={!!value || false}
                onChange={(e) => onChange(e.target.checked)}
                required={field.required}
            />
            {field.label}
        </label>
    ),
    CHOICE: (idPrefix, field, value, onChange) => (
        <Choice idPrefix={idPrefix} field={field} selected={value || []} onChange={onChange} />
    ),
    CHOICE_W_TEXT: (idPrefix, field, value, onChange) => (
        <Choice idPrefix={idPrefix} field={field} selected={value?.selection || []} onChange={(selection) => onChange({ selection })}>
            <Input required onChange={(e) => onChange({ selection: value?.selection, addon: e.target.value })} />
        </Choice>
    ),
    MULTIPLE_CHOICE: (idPrefix, field, value, onChange) => (
        <Choice
            idPrefix={idPrefix}
            multiple
            field={field}
            selected={value || []}
            onChange={onChange}
        />
    ),
    MULTIPLE_CHOICE_W_TEXT: (idPrefix, field, value, onChange) => (
        <Choice
            idPrefix={idPrefix}
            multiple
            field={field}
            selected={value?.selection || []}
            onChange={(selection) => onChange({ selection })}
        >
            <Input required onChange={(e) => onChange({ selection: value?.selection, addon: e.target.value })} />
        </Choice>
    ),
};

const Field = ({ idPrefix, field, value, onFieldChange }) => {
    const componentFactory = FIELDS[field.type];

    if (!componentFactory) {
        console.error("Kein Eingabeelement.", field.type);
        return null;
    }

    return (
        <div className={styles.Field}>
            {componentFactory(idPrefix, field, value, onFieldChange)}
        </div>
    );
};

const FormFields = function ({ idPrefix = "fields", fields, values, onFieldChange }) {
    return (
        <ol className={styles.FormFields}>
            {fields.map((field) => (
                <li>
                    <Field
                        idPrefix={idPrefix}
                        key={`${idPrefix}-${field.id}`}
                        field={field}
                        value={(values || {})[field.id]}
                        onFieldChange={(value) => {
                            console.debug({ field, value })
                            onFieldChange(field, value)
                        }}
                    />
                </li>
            ))}
        </ol>
    );
};

export default FormFields;
